import { Tooltip, Typography, useTheme } from "@mui/material";
import {
  GridRenderCellParams,
  GridTreeNodeWithRender,
} from "@mui/x-data-grid/models";
import React from "react";
import centsToDollars from "src/utils/currency";
import { currencyFormat } from "src/utils/formatters";

interface Props {
  val: GridRenderCellParams<any, any, any, GridTreeNodeWithRender>;
  tradeStatus?: String;
  colorCode?: boolean;
}

export default function RenderAmount({ val, colorCode }: Props) {
  const theme = useTheme();
  return (
    <Tooltip
      placement="top"
      title={
        <React.Fragment>
          <b>
            <em>{currencyFormat(centsToDollars(val.value ?? 0), "$")}</em>
          </b>
        </React.Fragment>
      }
    >
      <Typography
        variant="body1"
        style={{
          color: colorCode
            ? val.value > 0
              ? "#4caf50"
              : val.value < 0
              ? "#f44336"
              : undefined
            : undefined,
        }}
      >
        {currencyFormat(centsToDollars(val.value ?? 0), "$")}
      </Typography>
    </Tooltip>
  );
}
